"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = require("react");
var RadioGroup_1 = require("./RadioGroup");
function Radio(props) {
    var value = props.value, name = props.name, id = props.id;
    var context = react_1.useContext(RadioGroup_1.RadioGroupContext);
    var aria = {};
    var selected = context.selected === value;
    var onSelect = function () {
        context.onSelect(value);
    };
    return (react_1.default.createElement("label", { htmlFor: id, className: "radio inline-flex flex-items-top mar-t-xs" },
        react_1.default.createElement("input", __assign({ type: "radio", id: id, name: name, value: value }, aria, { onClick: onSelect, checked: selected })),
        react_1.default.createElement("div", { className: "radio-skin" }),
        react_1.default.createElement("span", { className: "rad-chk-txt", "aria-hidden": "true" }, name)));
}
exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/RadioGroup/Radio.js
// module id = 2377
// module chunks = 8